/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';
import { SubscriberIdDcRulesAccordionStyled, SubscriberIdDcRulesStyled } from './styled/SubscriberIdDcRulesStyled';

export const SubscriberIdDcRuleListSkeleton = () => {
    const dateStyles = { height: '32px', width: '220px' };
    return (
        <SubscriberIdDcRulesStyled>
            <SubscriberIdSkeletonStyled>
                <div className="subscriber-dc-rules__rule">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <div className="subscriber-dc-rules__date-block">
                        <SkeletonParagraph
                            className="subscriber-dc-rules__date"
                            kind={ESkeletonKind.BUTTON_ROUND}
                            style={dateStyles}
                        />
                        <SkeletonParagraph
                            className="subscriber-dc-rules__date"
                            kind={ESkeletonKind.BUTTON_ROUND}
                            style={dateStyles}
                        />
                    </div>
                </div>
                <div className="subscriber-dc-rules__rule">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <div className="subscriber-dc-rules__date-block">
                        <SkeletonParagraph
                            className="subscriber-dc-rules__date"
                            kind={ESkeletonKind.BUTTON_ROUND}
                            style={dateStyles}
                        />
                        <SkeletonParagraph
                            className="subscriber-dc-rules__date"
                            kind={ESkeletonKind.BUTTON_ROUND}
                            style={dateStyles}
                        />
                        <SkeletonParagraph
                            className="subscriber-dc-rules__date"
                            kind={ESkeletonKind.BUTTON_ROUND}
                            style={dateStyles}
                        />
                    </div>
                </div>
            </SubscriberIdSkeletonStyled>
            <SubscriberIdDcRuleActiveSkeleton/>
        </SubscriberIdDcRulesStyled>
    );
};

export const SubscriberIdDcRuleActiveSkeleton = () => {
    const accordionHeadStyles = { width: '75px' };
    const accordionItemStyles = { height: '72px' };
    return (
        <SubscriberIdSkeletonStyled>
            <div className="subscriber-dc-rules__block subscriber-dc-rules__accordion-list">
                <div className="subscriber-dc-rules-accordion__head">
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={accordionHeadStyles}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={accordionHeadStyles}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={accordionHeadStyles}/>
                </div>
                <SubscriberIdDcRulesAccordionStyled level={0}>
                    <SkeletonParagraph
                        kind={ESkeletonKind.BUTTON_ROUND}
                        style={accordionItemStyles}
                    />
                    <SkeletonParagraph
                        kind={ESkeletonKind.BUTTON_ROUND}
                        style={accordionItemStyles}
                    />
                    <SkeletonParagraph
                        kind={ESkeletonKind.BUTTON_ROUND}
                        style={accordionItemStyles}
                    />
                </SubscriberIdDcRulesAccordionStyled>
            </div>
        </SubscriberIdSkeletonStyled>
    );
};

